export default {
  title: {
    id: 'bo_seller.profile.legal_details.dsa_block.has_contact_detail.title',
    defaultMessage: 'Default contact for products',
  },
  subtitle: {
    id: 'bo_seller.profile.legal_details.dsa_block.has_contact_detail.subtitle',
    defaultMessage:
      'This information will appear on all your listings by default. To update and individual listing, go to the individual listing page > "Contact" > "Product specific" > "Add contact".',
  },
  editButton: {
    id: 'bo_seller.profile.legal_details.dsa_block.has_contact_detail.edit_button',
    defaultMessage: 'Edit',
  },
  phone: {
    id: 'bo_seller.profile.legal_details.dsa_block.has_contact_detail.phone',
    defaultMessage: 'Phone:',
  },
  email: {
    id: 'bo_seller.profile.legal_details.dsa_block.has_contact_detail.email',
    defaultMessage: 'Email:',
  },
  website: {
    id: 'bo_seller.profile.legal_details.dsa_block.has_contact_detail.website',
    defaultMessage: 'Website:',
  },
}
